module.exports = __webpack_public_path__ + "static/media/3.ef07619d.svg";